import _classCallCheck from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

/**
 * Returns the innermost error that has a message field.
 *
 * @internal
 * @param error - the error to unwrap
 * @returns - the innermost populated error
 */
function unwrap(error) {
  if (error.innererror !== undefined && error.innererror.message !== undefined) {
    return unwrap(error.innererror);
  }

  return error;
}
/**
 * A class representing an Error from the Form Recognizer Service.
 *
 * For information about the error codes the service produces, refer to the service's error documentation:
 *
 * https://aka.ms/azsdk/formrecognizer/errors
 */


export var FormRecognizerError = /*#__PURE__*/function (_Error) {
  _inherits(FormRecognizerError, _Error);

  /**
   * Create a FormRecognizerError from a generated ErrorModel.
   * @internal
   * @hidden
   */
  function FormRecognizerError(formRecognizerError) {
    var _this;

    _classCallCheck(this, FormRecognizerError);

    var _a; // TODO: We used to unwrap FR errors this way, but is it still necessary


    var e = unwrap(formRecognizerError);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(FormRecognizerError).call(this, e.message));
    _this.code = e.code;
    _this.details = (_a = e.details) !== null && _a !== void 0 ? _a : [];
    _this.target = e.target;
    return _this;
  }

  return FormRecognizerError;
}(_wrapNativeSuper(Error));